import Vue from 'vue/dist/vue.js'
import axios from 'axios'
import {
  CATEGORY_LIST_API,
  SUBCATEGORY_LIST_API,
  updateMetaTitle,
} from './consts'

export default function() {

  new Vue({
    el: '.js-category-list',
    name: 'Category List',
    data() {
      return {
        subOrCategoryList: [],
        categoryFilter: []
      };
    },
    async mounted() {
      let currentCategory = null;
      if (this.$el.dataset.subcategory) {
        const response = await axios.get(SUBCATEGORY_LIST_API + this.$el.dataset.subcategory);
        this.subOrCategoryList = response.data.data.categories;
        currentCategory = response.data.data;
        updateMetaTitle(response.data.data.name);
      } else if (this.$el.dataset.category) {
        const response = await axios.get(SUBCATEGORY_LIST_API + this.$el.dataset.category);
        this.subOrCategoryList = response.data.data.categories;
        currentCategory = response.data.data;
        updateMetaTitle(response.data.data.name);
      }

      const mainCategoryTree = await axios.get(CATEGORY_LIST_API);
      const categoryData = mainCategoryTree.data.data;
      categoryData.forEach(categoryItem => {
        categoryItem.active = window.location.pathname.includes(categoryItem.slug);
      });
      this.categoryFilter = categoryData;

      if (!this.$el.dataset.subcategory && !this.$el.dataset.category) {
        this.subOrCategoryList = categoryData;
        updateMetaTitle('Products');
      }

      // build breadcrumb
      let crumbs = [{name: 'Home', link: '/'}, {name: 'Products', link: '/products'}];
      if (currentCategory && currentCategory.parent_slug && currentCategory.parent_name) {
        crumbs.push({name: currentCategory.parent_name, link: `/products/${currentCategory.parent_slug}`})
      }

      if (currentCategory && currentCategory.slug && currentCategory.name) {
        if (currentCategory.parent_slug) {
          crumbs.push({name: currentCategory.name, link: `/products/${currentCategory.parent_slug}/${currentCategory.slug}`})
        } else {
          crumbs.push({name: currentCategory.name, link: `/products/${currentCategory.slug}`})
        }

        document.querySelector('[data-category-name]').textContent = currentCategory.name;
      }

      document.querySelector('[data-breadcrumbs]').innerHTML = crumbs.map(item => {
        return `<a href="${item.link}" class="small-button">${item.name}</a>`;
      }).join('<span>/</span>');


    },
    methods: {
      linkGenerator(categoryItem) {
        let parts = ['/products'];
        if (categoryItem.parent_slug) {
          parts.push(categoryItem.parent_slug);
        }
        if (categoryItem.slug) {
          parts.push(categoryItem.slug);
        }
        return parts.join('/');
      }
    },
  });
}
